export default "__VITE_ASSET__BIXGuK9r__"